<template>
  <div class="watchCardDataReport">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- 数量统计 -->
    <div class="totalBox flex-row ite-c jus-b boxs">
      <ul class="le-box">
        <li>
          <p class="tbTit">运营商数量</p>
          <p class="tbTotal">{{operatorNum}}</p>
        </li>
        <li>
          <p class="tbTit">号卡数量</p>
          <p class="tbTotal">{{numberCardNum}}</p>
        </li>
      </ul>
      <div class="ri-box">
        <button @click="getTotalDetail" class="butStyle greenBtn searchBtn">
          <!-- <i class="el-icon-search"></i> -->
          <span>详情查看</span>
        </button>
      </div>
    </div>

    <!-- 筛选条件 -->
    <div class="searchBox flex-row ite-c jus-b boxs">
        <ul class="colList boxs">
            <li>
              <span class="col-tit2">代理商</span>
              <el-select v-model="agentsForm.agent1" clearable filterable placeholder="请选择代理商" @change="agentChange">
                <el-option v-for="item in agentsForm.agentOptions1" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>

              <div v-if="agentsForm.agentOptions2.length>0 && agentsForm.agent1" class="agentSelect"> -
                <el-select v-model="agentsForm.agent2" clearable filterable placeholder="请选择下一级代理商" @change="agentChange2">
                  <el-option v-for="item in agentsForm.agentOptions2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div v-if="agentsForm.agentOptions3.length>0 && agentsForm.agent2" class="agentSelect"> -
                <el-select v-model="agentsForm.agent3" clearable filterable placeholder="请选择下二级代理商" @change="agentChange3">
                  <el-option v-for="item in agentsForm.agentOptions3" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div v-if="agentsForm.agentOptions4.length>0 && agentsForm.agent3" class="agentSelect"> -
                <el-select v-model="agentsForm.agent3" clearable filterable placeholder="请选择下二级代理商" @change="agentChange4">
                  <el-option v-for="item in agentsForm.agentOptions4" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>

            </li>
            <li>
              <el-checkbox v-model="isSelf" @change="isSelfChange">是否仅查自营</el-checkbox>
            </li>
        </ul>
        <div class="ri-box">
            <button @click="handleSearch" class="butStyle greenBtn searchBtn">
              <i class="el-icon-search"></i>
            </button>
        </div>
    </div>
    

    <!-- 号卡统计 -->
    <div class="comTotalBox numCardTotal flex-row jus-b boxs">
      <div class="le-name-box">
        <p class="total-tit">号卡统计</p>
      </div>
      <div class="ri-main-box boxs flex-row">
        <numcard-echart ref="numcardChart"></numcard-echart>
        <div class="riTotal" v-loading="numCardInfoLoading">
          <ul class="numCardTotalBox">
            <li>
              <span class="title">号卡总数</span>
              <div class="total blackFont">{{numCardTotal}}</div>
            </li>
            <div class="line"></div>
            <li>
              <span class="title">可激活数</span>
              <div class="total blueFont">{{activableNum}}</div>
            </li>
            <div class="line"></div>
            <li>
              <span class="title">已激活数</span>
              <div class="total lightBlueFont">{{activatedNum}}</div>
            </li>
            <div class="line"></div>
            <li>
              <span class="title">已停机数</span>
              <div class="total lightGreenFont">{{outageNum}}</div>
            </li>
            <div class="line"></div>
            <li>
              <span class="title">本月到期</span>
              <div class="total greenFont">{{thisMonthExpires}}</div>
            </li>
          </ul>
          <button @click="goNumCardDataList" class="butStyle greenBtn dataListBtn">
            <span>查看数据列表</span>
          </button>
        </div>

      </div>
    </div>

    <!-- 佣金统计 -->
    <div class="comTotalBox commissionTotal flex-row jus-b boxs">
      <div class="le-name-box">
        <p class="total-tit">佣金统计</p>
      </div>
      <div class="ri-main-box boxs">
        <!-- 佣金统计右边-第一行筛选条件 -->
        <ul class="topSearchLine">
          <li>
            <span>时间</span>
            <el-date-picker
                    v-model="searchYearMonth"
                    type="month"
                    placeholder="选择年月"
                    value-format="yyyyMM"
                    :picker-options="pickerOptions"
                    :clearable="false"
                    @change="yearMonthChange"
            >
            </el-date-picker>
          </li>
          <li>
            <span>套餐</span>
            <el-select v-model="packageIds" clearable filterable placeholder="请选择套餐" @change="packageChange">
              <el-option v-for="item in packageOptions" :key="item.name" :label="item.name" :value="item.packageId"></el-option>
              <!-- <el-option v-for="item in packageOptions" :key="item.id" :label="item.name" :value="item.id"></el-option> -->
            </el-select>
          </li>
        </ul>

        <!-- 佣金统计右边-下方总数和图表 -->
        <ul class="botContent">
          <li class="comTotalChartBox">
            <div class="leMonthTotal">
              <p class="monthName">本月激活数</p>
              <p class="monthCount">{{monthlyActivationTotal}}</p>
            </div>
            <div class="riChart">
              <columnar-echart1 ref="actChart"></columnar-echart1>
              <!-- <columnar-echart></columnar-echart> -->
            </div>
          </li>
          <li class="comTotalChartBox">
            <div class="leMonthTotal">
              <p class="monthName">本月佣金</p>
              <p class="monthCount">{{monthlyCommissionTotal}}</p>
              <button @click="goCommissionDataList" class="butStyle greenBtn dataListBtn">
                <span>查看数据列表</span>
              </button>
            </div>
            <div class="riChart">
              <columnar-echart2 ref="commChart"></columnar-echart2>
            </div>
          </li>

        </ul>

      </div>
    </div>

    <!-- 会员统计 -->
    <div class="comTotalBox memberTotal flex-row jus-b boxs">
      <div class="le-name-box">
        <p class="total-tit">会员统计</p>
      </div>
      <div class="ri-main-box boxs">
        <!-- 第一行标题会员名称 -->
        <p class="topTitleLine flex-row jus-b boxs">
          <span class="leTit">
            <b>{{memberTitle.currentMember}}</b>
             <span v-show="memberTitle.subMember!==''">-{{memberTitle.subMember}}</span>
          </span>
          <span class="riBtn">
            <!-- <button  -->
            <button v-if="memberLevelcount > 0"
                    @click="getBackTopLevel" 
                    class="butStyle greenBtn goBackBtn">
              <span>返回上一级</span>
            </button>
          </span>
        </p>

        <!-- 中间统计 -->
        <ul class="miTotalLine">
          <li>
            <p class="topTit">会员数</p>
            <p class="botTotal">{{memberNum}}</p>
          </li>
          <li>
            <p class="topTit">拿卡数</p>
            <p class="botTotal">{{takeCardNum}}</p>
          </li>
        </ul>

        <!-- 下级代理商区域 -->
        <div class="agentsArea" :v-loading="memberAgentsLoading">
          <div class="singleAgent" v-for="(item,index) in lowerLevelAgentInfo">
            <div class="agentCircle">
              <p class="circleTop">拿卡量</p>
              <p class="circleMiddle">{{item.card_count}}</p>
              <p class="circleBottom"
                 v-if="item.is_have_detail && item.is_have_detail==1"
                 @click="getAllAgentInfo(item.member_id, item.member_name)"
              >
                下级明细
              </p>
            </div>
            <div class="agentName" :title="item.member_name">{{item.member_name}}</div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import TitleBox from '@/components/Common/TitleBox/TitleBox';
    import NumcardEchart from './../Echart/NumCardTotalChart/NumcardEchart'; // 饼图(环形图)
    import ColumnarEchart1 from './../Echart/ColumnarChart/ColumnarEchart1'; // 柱状图1
    import ColumnarEchart2 from './../Echart/ColumnarChart/ColumnarEchart2'; // 柱状图2
    import {formatDate} from '@/utils/dateFormatter';
    import {centsToYuan} from '@/utils/unitConverter';
    import {
        getOperatorCount, // 获取运营商数量
        getCardCount, // 获取号卡数量
        getMultipleStatusNum, // 首页获取号码多种状态数量

        getAgentsMap, // 获取指定会员的下一级代理商

        getPackagesSel, // 获取套餐
        getMonthlyActivationReq, // 获取月激活数总和
        getActDayStatReq, // 统计激活数日分析
        getMonthlyCommissionReq, // 获取月佣金总和
        getCommDayStatReq, // 统计佣金日分析

        getCurrentLoginMemberInfoReq, // 获取当前登录会员信息
        getUpOneLevelMemberReq, // 获取指定会员的上一级
        getNextLevelMemberCountReq, // 获取指定会员的下一级代理商数量
        getNextLevelCardCountReq, // 获取指定会员的下一级拿卡总量
        getNextLevelMemberCardDetailReq, // 获取指定会员的下一级代理商拿卡明细

    } from '@/api/Report/Watch/dataReport.js';

    // 查询代理商数据
    const defaultAgentsForm = {
        agent1: null, //代理商
        agent2: null, //代理商2
        agent3: null, //代理商3
        agent4: null, //代理商4
        agentOptions1: [],//代理商数组
        agentOptions2: [],//代理商数组2
        agentOptions3: [],//代理商数组3
        agentOptions4: [],//代理商数组4
    }

    export default {
        name: "watchCardDataReportIndex",
        data() {
            return {
                //标题
                topTitle: {
                    title: '腕表卡业务数据报表',
                    subTit: ''
                },

                operatorNum: 0,// 运营商数量
                numberCardNum: 0,// 号卡数量

                // 筛选条件
                search: {
                    // agentId: undefined,
                    member_id: null, //当前选中代理商的id
                    business_type: 1, //卡类型：1:腕表卡，2:大流量卡
                    self_support: 2, //是否仅查自营：1:是，2:否
                },
                search_cache: {},
                // searchForm: Object.assign({}, defaultSearchForm),
                // 查询代理商数据
                agentsForm: Object.assign({}, defaultAgentsForm),
                isSelf: false, //是否自营

                // 号卡统计
                numCardInfoLoading: false, //号卡信息加载
                numCardTotal: 0, //号卡总数
                activableNum: 0, //可激活数
                activatedNum: 0, //已激活数
                outageNum: 0, //已停机数
                thisMonthExpires: 0, //本月到期

                // 佣金统计
                searchYearMonth: formatDate(new Date(), 'yyyyMM'), //查询条件-年月
                packageOptions: [], //查询条件-套餐
                packageIds: null, //套餐Id：包括套餐ID和产品ID
                // product_id: null, //产品ID
                monthlyActivationTotal: 0, //本月激活数
                monthlyCommissionTotal: 0, //本月佣金
                activationChartData: [], //日分析数据-激活数
                commissionChartData: [], //日分析数据-佣金

                // 会员统计
                memberTitle: {//会员标题
                    currentMember: null,
                    currentMemberName: null,
                    currentMemberId: null,
                    subMember: ''// 被查询的下级会员
                },
                memberArr:[], //存储当前登录会员和点击的每一个“下级会员”
                memberNum: 0, // 会员数
                takeCardNum: 0, // 拿卡数
                lowerLevelAgentInfo: [], //下级代理商信息
                memberLevelcount: 0, //会员统计-显示的会员/代理商是当前登录会员名下的第几级（0代表显示的是当前登录会员的下一级会员，越往下一级数字越大）
                memberIdForNoCurrentLogin: null, //非当前登录账号的会员(会员统计中被点击“下级明细”的代理商)
                memberAgentsLoading: false, //下级代理商加载
                firstClickBack: false, //查询下级会员后，第一次点击“返回上一级”按钮

                // 日期时间选择器
                pickerOptions: {
                    // 大于今天的日期不可选
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                }

            }
        },
        created () {
            // 获取下一级代理商
            this.initAgentOption();

            // 首页获取运营商数量
            this.getOperatorCount();
            // 首页获取号卡数量
            this.getCardCount();

            // 首页获取号码多种状态数量
            this.getMultipleStatusNum();

            // 获取当前登录会员信息
            this.getCurrentLoginMemberInfo();
            // 获取指定会员的所有下一级信息
            this.getAllAgentInfo();
        },
        methods: {
            // 首页获取运营商数量
            getOperatorCount() {
                let reqParam = {
                    business_type: this.search.business_type
                };
                getOperatorCount(reqParam).then(res => {
                  // console.log(res)
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.operatorNum = res.body.operatorCount;
                }).catch(err => {
                    console.log(err)
                })
            },
            // 首页获取号卡数量
            getCardCount() {
                let reqParam = {
                    business_type: this.search.business_type
                };
                getCardCount(reqParam).then(res => {
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.numberCardNum = res.body.cardCount;
                }).catch(err => {
                    console.log(err)
                })
            },
            // 详情查看（数量统计）[跳转]
            getTotalDetail() {
                this.$router.push({
                    path: 'dataReportDetail',
                    query: {
                        title: this.topTitle.title,
                        business_type: this.search.business_type,
                    }
                })
            },

            // 搜索按钮
            handleSearch() {
              // 首页获取号码多种状态数量
              this.getMultipleStatusNum();

              // 获取当前佣金和激活数的月总数和日分析
              this.getAllActiAndCommiData();

              // 获取当前登录会员信息
              this.getCurrentLoginMemberInfo();
              // 获取指定会员的所有下一级信息
              this.getAllAgentInfo();
            },

            // 切换是否自营
            isSelfChange() {
              if(this.isSelf == true){
                this.search.self_support = 1
              } else if (this.isSelf == false) {
                this.search.self_support = 2
              }
            },

            // 获取下一级代理商
            initAgentOption() {
                // 获取套餐
                this.getPackagesOptions();
                getAgentsMap(this.search).then(res => {
                    // if (res.header && res.header.code != 0) {
                    //   // this.$message.error(res.header.message);
                    //   return
                    // }
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.agentsForm.agentOptions1 = res;
                    // var rows = unescape(JSON.stringify(res.body));
                    // this.agentsForm.agentOptions1 = JSON.parse(rows);
                }).catch(err => {
                    console.log(err)
                })
            },
            // 切换代理商
            agentChange(val) {
                this.agentsForm.agentOptions2 = []
                this.search.member_id = this.agentsForm.agent1;

                // 获取选中的代理商名称（会员名）
                let obj = {};
                obj = this.agentsForm.agentOptions1.find((item)=>{
                    return item.id === val;
                });
                this.memberTitle.currentMemberName = obj.name;

                // 获取套餐
                this.getPackagesOptions(this.search.member_id);

                getAgentsMap(this.search).then(res => {
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.agentsForm.agentOptions2 = res;
                }).catch(err => {
                    console.log(err)
                })
            },
            // 切换代理商2
            agentChange2(val) {
                this.agentsForm.agentOptions3 = []
                if(!this.agentsForm.agent2){
                    // 第2个代理商为空时，全局代理商=第1个代理商
                    this.search.member_id = this.agentsForm.agent1;
                } else {
                    this.search.member_id = this.agentsForm.agent2;
                }

                // 获取选中的代理商名称（会员名）
                let obj = {};
                obj = this.agentsForm.agentOptions2.find((item)=>{
                    return item.id === val;
                });
                this.memberTitle.currentMemberName = obj.name;

                // 获取套餐
                this.getPackagesOptions(this.search.member_id);

                getAgentsMap(this.search).then(res => {
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.agentsForm.agentOptions3 = res;
                }).catch(err => {
                    console.log(err)
                })
            },
            // 切换代理商3
            agentChange3(val) {
                this.agentsForm.agentOptions4 = []
                if(!this.agentsForm.agent3){
                    // 第3个代理商为空时，全局代理商=第2个代理商
                    this.search.member_id = this.agentsForm.agent2;
                } else {
                    this.search.member_id = this.agentsForm.agent3;
                }
                
                // 获取选中的代理商名称（会员名）
                let obj = {};
                obj = this.agentsForm.agentOptions3.find((item)=>{
                    return item.id === val;
                });
                this.memberTitle.currentMemberName = obj.name;

                // 获取套餐
                this.getPackagesOptions(this.search.member_id);

                getAgentsMap(this.search).then(res => {
                    if (!res || res.length <= 0) {
                        return;
                    }
                    this.agentsForm.agentOptions4 = res;
                }).catch(err => {
                    console.log(err)
                })
            },
            // 切换代理商4
            agentChange4(val) {
                // this.agentsForm.agentOptions5 = []
                if(!this.agentsForm.agent4){
                    // 第4个代理商为空时，全局代理商=第3个代理商
                    this.search.member_id = this.agentsForm.agent3;
                } else {
                    this.search.member_id = this.agentsForm.agent4;
                }
                
                // 获取选中的代理商名称（会员名）
                let obj = {};
                obj = this.agentsForm.agentOptions4.find((item)=>{
                    return item.id === val;
                });
                this.memberTitle.currentMemberName = obj.name;

                // 获取套餐
                this.getPackagesOptions(this.search.member_id);

                // getAgentsMap(this.search).then(res => {
                //     if (!res || res.length <= 0) {
                //         return;
                //     }
                //     this.agentsForm.agentOptions5 = res;
                // }).catch(err => {
                //     console.log(err)
                // })
            },



            // 号卡统计-查看数据列表[跳转]
            goNumCardDataList() {
                this.$router.push({
                    path: 'numCardDataList',
                    query: {
                        title: this.topTitle.title,
                        business_type: this.search.business_type,
                        member_id: this.search.member_id,
                        self_support: this.search.self_support,
                        currentMember: this.memberTitle.currentMember,
                        member_name: this.memberTitle.currentMemberName
                    }
                })
            },
            // 首页获取号码多种状态数量(号卡统计-查询号卡统计信息)
            getMultipleStatusNum() {
                getMultipleStatusNum(this.search).then(res => {
                    this.numCardTotal = res.body.allNumberNum;
                    this.activatedNum = res.body.isActiveNum;
                    this.activableNum = res.body.noActiveNum;
                    this.outageNum = res.body.isStopNum;
                    this.thisMonthExpires = res.body.isExpireNum;

                    var serviceData = [
                        {value: parseInt(this.activableNum), name:'可激活数'},
                        {value: parseInt(this.activatedNum), name:'已激活数'},
                        {value: parseInt(this.outageNum), name:'已停机数'},
                        {value: parseInt(this.thisMonthExpires), name:'本月到期'},
                    ];
                    var legendData = ['可激活数', '已激活数', '已停机数', '本月到期'];
                    // 渲染号卡统计环形图
                    this.$refs.numcardChart.getDataAndDraw(serviceData, legendData);
                    // console.log('渲染号卡统计环形图serviceData', serviceData)

                }).catch(err => {
                    console.log(err)
                })
            },


            // 佣金统计-获取套餐下拉框
            getPackagesOptions(agentId) {
                let packageParma = {
                    agent: agentId,
                    business_type: this.search.business_type
                };
                getPackagesSel(packageParma).then(res => {

                    //如果存在packageId则取packageId，否则取product_id
                    res.body.forEach(value =>{
                        if(value.id.package_id){
                            value.packageId =value.id.package_id;
                        }else{
                            value.packageId =value.id.product_id;
                        }
                    });
                    this.packageOptions = res.body;
                    // this.packageOptions.unshift({id: {product_id: null}, name: "所有套餐"})
                    this.$nextTick(() => {
                        // 获取月激活数总和
                        // 获取日激活数
                        // 获取月佣金总和
                        // 获取日佣金
                        this.getAllActiAndCommiData();
                    })
                }).catch(err => {
                    console.log(err)
                })
            },
            // 佣金统计-切换年月
            yearMonthChange() {
              // console.log('searchYearMonth', this.searchYearMonth)
                this.$nextTick(() => {
                    // 获取月激活数总和
                    // 获取日激活数
                    // 获取月佣金总和
                    // 获取日佣金
                    this.getAllActiAndCommiData();
                })
            },
            // 佣金统计-切换套餐
            packageChange() {
                // console.log('packageChange-packageIds', this.packageIds);
                this.$nextTick(() => {
                    // 获取月激活数总和
                    // 获取日激活数
                    // 获取月佣金总和
                    // 获取日佣金
                    this.getAllActiAndCommiData();
                })
            },
            // 佣金统计-获取月激活数总和
            getMonthlyActivation (data) {
                getMonthlyActivationReq(data).then(response => {
                    this.monthlyActivationTotal = response.body.rows[0].num
                }).catch(err => {
                    console.log(err);
                })
            },
            // 佣金统计-统计激活数日分析
            getActDayStat (data) {
                getActDayStatReq(data).then(response => {
                    this.activationChartData = response.body

                    let arr1 = this.activationChartData;
                    let xAxisData = []; //x轴数据（字符串）
                    let serviceData = []; //y轴数据（数字）
                    arr1.forEach(value =>{
                        xAxisData.push(value.day);
                        serviceData.push(parseInt(value.commission));
                    })
                    // 渲染激活数柱状图
                    this.$refs.actChart.getDataAndDraw(xAxisData, serviceData);
                }).catch(err => {
                    console.log(err);
                })
            },

            // 佣金统计-获取月佣金总和
            getMonthlyCommission (data) {
                getMonthlyCommissionReq(data).then(response => {
                    this.monthlyCommissionTotal = centsToYuan(response.body.total_commission)
                }).catch(err => {
                    console.log(err);
                })
            },
            // 佣金统计-统计佣金日分析
            getCommDayStat (data) {
                const p =  {
                    business_type: data.business_type,
                    agent: data.agent,
                    date: data.max_date,
                    package_id: data.package_id,
                    self_support: this.search.self_support
                }
                getCommDayStatReq(p).then(response => {
                    this.commissionChartData = response.body
                    this.commissionChartData.forEach(value =>{
                        value.commission = centsToYuan(value.commission)
                        // var a = "￥"
                        // value.commission = a + value.commission
                    })

                    let arr1 = this.commissionChartData;
                    let xAxisData = []; //x轴数据（字符串）
                    let serviceData = []; //y轴数据（数字）
                    arr1.forEach(value =>{
                        xAxisData.push(value.day);
                        serviceData.push(parseInt(value.commission));
                    })
                    // 渲染佣金柱状图
                    this.$refs.commChart.getDataAndDraw(xAxisData, serviceData);

                }).catch(err => {
                    console.log(err);
                })
            },
            // 获取当前佣金和激活数的月总数和日分析
            getAllActiAndCommiData() {
                this.commissionChartData = []
                this.activationChartData = []

                // 激活数请求参数
                var monthSrt = this.searchYearMonth.toString();
                var monthFormat = monthSrt.substring(0,4) + '-' + monthSrt.substring(4,6);
                const activationParam = {
                    business_type: this.search.business_type,
                    member_id: this.search.member_id,
                    month: monthFormat,
                    package_id: this.packageIds,
                    self_support: this.search.self_support
                }
                // 获取月激活数总和
                this.getMonthlyActivation(activationParam)
                // 获取日激活数
                this.getActDayStat(activationParam)

                // 佣金请求参数
                const commissionParam = {
                    business_type: this.search.business_type,
                    agent: this.search.member_id,
                    max_date: this.searchYearMonth.toString(),
                    package_id: this.packageIds,
                    self_support: this.search.self_support
                    // product_id: this.product_id,
                }
                // 获取月佣金总和
                this.getMonthlyCommission(commissionParam)
                // 获取日佣金
                this.getCommDayStat(commissionParam)
            },
            // 佣金统计-查看数据列表[跳转]
            goCommissionDataList() {
                this.$router.push({
                    path: 'commissionDataList',
                    query: {
                        title: this.topTitle.title,
                        business_type: this.search.business_type,
                        member_id: this.search.member_id,
                        month: this.searchYearMonth.toString(),
                        package_id: this.packageIds,
                        self_support: this.search.self_support
                    }
                })
            },



            // 会员统计-获取指定会员的所有下一级信息(点击“下级明细”)
            // 注：is_have_detail：1是有下级会员，0是没有下级会员
            getAllAgentInfo(member_id, member_name) {
                // 先处理点击“下级明细”的情况
                if(member_id && member_name){
                    // 显示被查询的下级会员名
                    this.memberTitle.subMember = member_name;
                    // 每次点“下级明细”，当前显示的会员/代理商是当前登录账号的会员名下的层级+1，即下一层、下两层代理等
                    this.memberLevelcount += 1;
                    // 非当前登录账号的会员(会员统计中被点击“下级明细”的代理商)
                    // 也是当前查询号卡信息的会员，注意这个会员是当前登录账号的会员的所有下级中的一员
                    this.memberIdForNoCurrentLogin = member_id;
                    this.memberArr.push(member_id)
                    // console.log('下级明细this.memberArr', this.memberArr)
                    this.firstClickBack = true
                    // console.log('下级明细this.firstClickBack', this.firstClickBack)
                }

                this.getNextLevelMemberCount(member_id)
                this.getNextLevelCardCount(member_id)
                this.getNextLevelMemberCardDetail(member_id)
            },
            
            // 返回上一级会员
            getBackTopLevel() {

                // // 存储根据指定会员查询到的上级会员
                // let currentUpOneLevelMemberName = null;
                // let currentUpOneLevelMemberId = null;

                // // 先查询指定会员的上一级会员-获取指定会员的上一级
                // getUpOneLevelMemberReq({member_id: this.memberIdForNoCurrentLogin}).then(res => {
                //     if (res.header.code != 0) {
                //         // code不为0代表没有上级会员
                //         // 显示的会员/代理商是当前登录会员名下的第几级（0代表显示的是当前登录会员的下一级会员，越往下一级数字越大）
                //         this.memberLevelcount = 0;
                //         this.memberTitle.subMember = ''; //隐藏被查询的下级会员名
                //         return;
                //     }

                //     currentUpOneLevelMemberName = res.body.NAME
                //     currentUpOneLevelMemberId = res.body.ID

                //     // 如果获取的上一级会员是当前登录账号的会员（隐藏“返回上一级”按钮和只显示当前登录的会员名称）
                //     if(currentUpOneLevelMemberName == this.memberTitle.currentMember){
                //         this.memberLevelcount = 0;
                //         this.memberTitle.subMember = '';
                //     }

                //     // 再查询上一级会员的所有下一级信息
                //     this.getNextLevelMemberCount(currentUpOneLevelMemberId)
                //     this.getNextLevelCardCount(currentUpOneLevelMemberId)
                //     this.getNextLevelMemberCardDetail(currentUpOneLevelMemberId)

                // }).catch(err => {
                //     console.log(err);
                // })



                // console.log('返回上一级会员this.memberArr', this.memberArr)
                // console.log('返回上一级会员this.firstClickBack', this.firstClickBack)
                // 上一级会员id
                var arrLastOne = null
                arrLastOne = this.memberArr.pop()
                

                // if(this.firstClickBack== true) {
                //   var popOne = this.memberArr.pop()
                //   arrLastOne = this.memberArr.pop()
                //   this.firstClickBack = false
                // } else if(this.firstClickBack == false) {
                //   arrLastOne = this.memberArr.pop()
                // }
                // console.log('arrLastOne', arrLastOne)

                if( arrLastOne != this.memberTitle.currentMemberId){
                    getUpOneLevelMemberReq({member_id: arrLastOne}).then(res => {
                        if (res.header.code != 0) {
                            // code不为0代表没有上级会员
                            // 显示的会员/代理商是当前登录会员名下的第几级（0代表显示的是当前登录会员的下一级会员，越往下一级数字越大）
                            this.memberLevelcount = 0;
                            this.memberTitle.subMember = ''; //隐藏被查询的下级会员名
                            arrLastOne = null
                        } else if(this.memberTitle.currentMember == res.body.NAME){
                        // 查到的上一级会员名= 当前登录会员名
                            this.memberLevelcount = 0;
                            this.memberTitle.subMember = '';
                            arrLastOne = null;
                        } else {
                          this.memberTitle.subMember = res.body.NAME
                          arrLastOne = res.body.ID
                        }

                        // 再查询上一级会员的所有下一级信息
                        this.getNextLevelMemberCount(arrLastOne)
                        this.getNextLevelCardCount(arrLastOne)
                        this.getNextLevelMemberCardDetail(arrLastOne)
                        
                    }).catch(err => {
                        console.log(err);
                    })

                } else if (arrLastOne == this.memberTitle.currentMemberId) {
                    arrLastOne = null
                    this.memberLevelcount = 0;
                    this.memberTitle.subMember = '';

                    // 再查询上一级会员的所有下一级信息
                    this.getNextLevelMemberCount(arrLastOne)
                    this.getNextLevelCardCount(arrLastOne)
                    this.getNextLevelMemberCardDetail(arrLastOne)
                  
                }

                // 先查询指定会员的上一级会员-获取指定会员的上一级
                // getUpOneLevelMemberReq({member_id: this.memberIdForNoCurrentLogin}).then(res => {
                

                // // 如果获取的上一级会员是当前登录账号的会员（隐藏“返回上一级”按钮和只显示当前登录的会员名称）
                // if(arrLastOne == this.memberTitle.currentMemberId){
                //   this.memberLevelcount = 0;
                //   this.memberTitle.subMember = '';
                //   arrLastOne = null
                // }

                // // 再查询上一级会员的所有下一级信息
                // this.getNextLevelMemberCount(arrLastOne)
                // this.getNextLevelCardCount(arrLastOne)
                // this.getNextLevelMemberCardDetail(arrLastOne)
            },

            // 会员统计-获取当前登录会员信息
            getCurrentLoginMemberInfo () {
                this.memberArr = []
                getCurrentLoginMemberInfoReq().then(res => {
                    this.memberTitle.currentMember = res.body.name
                    this.memberTitle.currentMemberId = res.body.id
                    // this.memberArr.push(this.memberTitle.currentMember)
                    this.memberArr.push(this.memberTitle.currentMemberId)
                    // console.log('获取当前登录会员信息this.memberArr', this.memberArr)
                }).catch(err => {
                    console.log(err);
                })
            },

            // 会员统计-获取指定会员的下一级代理商数量
            getNextLevelMemberCount (data) {
                let param = {
                    business_type: this.search.business_type,
                    member_id: this.search.member_id,
                    self_support: this.search.self_support
                }
                if(data){
                    param.member_id = data
                }
                getNextLevelMemberCountReq(param).then(res => {
                    this.memberNum = res.body.member_count
                }).catch(err => {
                    console.log(err);
                })
            },

            // 会员统计-获取指定会员的下一级拿卡总量
            getNextLevelCardCount (data) {
                let param = {
                    business_type: this.search.business_type,
                    member_id: this.search.member_id,
                    self_support: this.search.self_support
                }
                if(data){
                    param.member_id = data
                }
                getNextLevelCardCountReq(param).then(res => {
                    this.takeCardNum = res.body.card_count
                }).catch(err => {
                    console.log(err);
                })
            },

            // 会员统计-指定会员的下一级代理商拿卡明细
            getNextLevelMemberCardDetail(data) {
                let param = {
                    business_type: this.search.business_type,
                    member_id: this.search.member_id,
                    self_support: this.search.self_support
                }
                if(data){
                    param.member_id = data
                }
                this.lowerLevelAgentInfo = []
                getNextLevelMemberCardDetailReq(param).then(res => {
                    this.lowerLevelAgentInfo = res.body
                }).catch(err => {
                    console.log(err);
                })
            },



        },
        components:{
            TitleBox,
            NumcardEchart,
            ColumnarEchart1,
            ColumnarEchart2,
        }
    }
</script>

<style scoped>
  .watchCardDataReport{
    /* padding-bottom: 92px; */
    min-width: 550px;
  }

  /* 字体颜色 */
  .blackFont{
    color: #333333;
  }
  .blueFont{
    color: #1F78B4;
  }
  .lightBlueFont{
    color: #A6CEE3;
  }
  .lightGreenFont{
    color: #B2DF8A;
  }
  .greenFont{
    color: #33A02C;
  }

  /* 数量统计 */
  .totalBox{
    width: 100%;
    padding: 12px 0;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #E4E4E4;
  }
  .totalBox .le-box {
    padding-left: 12px;
  }
  .totalBox .ri-box {
    padding-right: 12px;
  }
  .totalBox .le-box li{
    float: left;
    width: 200px;
    /* width: 19%; */
    height: 64px;
    padding: 12px 10px 7px;
    background: #1DB56F;
    color:#FFFFFF;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 5px;
    -o-border-radius: 5px;
    -webkit-border-radius: 5px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
  }
  .totalBox li+li{
    margin-left: 10px
  }
  .totalBox li:nth-child(2){
    background: #FFC400;
  }
  .totalBox li .tbTit{
    font-size: 13px;
    height: 17px;
    line-height: 17px;
  }
  .totalBox li .tbTotal{
    font-size: 20px;
    height: 26px;
    line-height: 26px;
    text-align: end;
  }


  /* 筛选条件 */
  .searchBox{
    width: 100%;
    padding: 12px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid #E4E4E4;
  }
  .searchBox .operatorName{
    width: 190px;
  }
  .searchBox .agentSelect {
    display: inline;
}

  /* 统计盒子公共样式 */
  .comTotalBox{
    width: 100%;
    margin-top: 20px;
  }
  .comTotalBox .le-name-box{
    width: 128px;
    min-width: 128px;
    /* height: 174px; */
    /* background: #1DB56F border-box url('../../../../../assets/images/report/DataReport/le-name1.png') bottom/128px no-repeat; */
    border-radius: 7px;
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
  }
  .comTotalBox .le-name-box p.total-tit{
    margin: 24px 0 0 10px;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
  }
  .comTotalBox .ri-main-box{
    width: calc( 100% - 128px - 10px );
    min-width: 922px;
    margin-left: 10px;
    border: 1px solid #E4E4E4;
    border-radius: 7px;
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
  }


  /* 号卡统计 */
  .numCardTotal{
  }
  .numCardTotal .le-name-box{
    height: 174px;
    background: #1DB56F border-box url('../../../../../assets/images/report/DataReport/le-name1.png') bottom/128px no-repeat;
  }
  .numCardTotal .ri-main-box{
    /* background-color: rgb(218, 192, 192) */
  }
  .numCardTotal .ri-main-box .riTotal{
    width: calc( 100% - 200px );
  }
  .numCardTotal .ri-main-box .numCardTotalBox{
    height: 67px;
    margin-top: 34px;
    display: flex;
    flex-flow: row nowrap;
    justify-content:space-evenly;
  }
  .numCardTotal .ri-main-box .numCardTotalBox .line{
    height: 36px;
    margin-top: 27px;
    border-right: 1px solid #E4E4E4;
  }
  .numCardTotal .ri-main-box .numCardTotalBox span.title{
    height: 19px;
    line-height: 19px;
    color: #999999;
    font-size: 14px;
    font-weight: bold;
  }
  .numCardTotal .ri-main-box .numCardTotalBox .total{
    height: 44px;
    line-height: 44px;
    padding-top: 4px;
    font-weight: bold;
    font-size: 36px;
    display: flex;
    justify-content: center;
  }
  .numCardTotal .ri-main-box .dataListBtn{
    margin-top: 16px;
    margin-left: 20px;
    height: 34px;
    line-height: 34px;
    font-size: 12px;
    border-radius: 7px;
  }
  .numCardTotal .ri-main-box .dataListBtn span{
    padding: 0 10px;
  }


  /* 佣金统计 */
  .commissionTotal{
  }
  .commissionTotal .le-name-box{
    min-height: 477px;
    background: #FFD444 border-box url('../../../../../assets/images/report/DataReport/le-name2.png') bottom/128px no-repeat;
  }
  .commissionTotal .ri-main-box{
    padding: 0 12px 12px;
  }
  /* 佣金统计右边-第一行筛选条件 */
  .commissionTotal .ri-main-box .topSearchLine{
    width: 100%;
    height: 60px;
    line-height: 60px;
  }
  .commissionTotal .ri-main-box .topSearchLine li{
    display: inline;
  }
  .commissionTotal .ri-main-box .topSearchLine li+li{
    margin-left: 30px;
  }
  .commissionTotal .ri-main-box .topSearchLine li span {
    margin-right: 10px;
    color: #333333;
    font-size: 14px;
  }

  /* 佣金统计右边-下方总数和图表 */
  .commissionTotal .ri-main-box .botContent{
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
  }
  .botContent li.comTotalChartBox{
    width: 100%;
    min-height: 174px;
    /* display: block; */
    /* display: flex;
    flex-flow: row nowrap; */
  }
  .botContent li+li{
    margin-top: 48px;
  }
  .botContent li.comTotalChartBox .leMonthTotal{
    float: left;
    /* display: inline-block; */
    min-height: 174px;
    width: 107px;
    text-align: center;
    /* margin: auto 0; */
  }
  .botContent li.comTotalChartBox .leMonthTotal .monthName{
    color: #999999;
    font-size: 14px;
    font-weight: bold;
    margin-top: 28px;
  }
  .botContent li.comTotalChartBox .leMonthTotal .monthCount{
    color: #333333;
    font-size: 36px;
    font-weight: blod;
    margin-top: 8px;
    height: 44px;
    line-height: 44px;
  }
  .botContent li.comTotalChartBox .leMonthTotal .dataListBtn{
    height: 34px;
    line-height: 34px;
    font-size: 12px;
    border-radius: 7px;
    margin-top: 24px;
  }
  .botContent li.comTotalChartBox .leMonthTotal .dataListBtn span{
    padding: 0 10px;
  }
  .botContent li.comTotalChartBox .riChart{
    /* display: inline-block; */
    /* float: left; */
    margin-left: 20px;
    /* background: #eef8e8; */
  }


  /* 会员统计 */
  .memberTotal{
  }
  .memberTotal .le-name-box{
    min-height: 268px;
    background: #A6CEE3 border-box url('../../../../../assets/images/report/DataReport/le-name3.png') bottom/128px no-repeat;
  }
  .memberTotal .ri-main-box{
  }
  /* 第一行标题会员名称 */
  .memberTotal .ri-main-box .topTitleLine{
    width: 100%;
    height: 44px;
    line-height: 44px;
  }
  .memberTotal .topTitleLine .leTit{
    color: #333333;
    font-size: 14px;
    font-weight: bold;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .memberTotal .leTit b{
    color: #333333;
    font-size: 14px;
    margin-left: 12px;
  }
  .memberTotal .leTit b::before{
    content: '';
    display: inline-block;
    height: 19px;
    width: 6px;
    background: #1DB56F;
    margin-right: 10px;
    vertical-align: middle;
  }
  .memberTotal .leTit span{
    color:#7F7F7F;
    font-size: 12px;
  }

  .memberTotal .topTitleLine .riBtn{
    /* width: 84px; */
    margin-right: 10px;
  }
  .memberTotal .topTitleLine .riBtn .goBackBtn{
    width: 84px;
    height: 34px;
    line-height: 34px;
    font-size: 13px;
  }


  /* 中间统计 */
  .memberTotal .ri-main-box .miTotalLine{
    width: 100%;
    margin-left: 12px;
    background: rgb(130, 182, 218);
  }
  .memberTotal .miTotalLine li{
    float: left;
    width: 200px;
    height: 64px;
    padding: 12px 10px 7px;
    background: #B2DF8A;
    color:#FFFFFF;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border-radius: 5px;
    -o-border-radius: 5px;
    -webkit-border-radius: 5px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
  }
  .memberTotal .miTotalLine li+li{
    margin-left: 10px;
  }
  .memberTotal .miTotalLine li:nth-child(2){
    background: #FFAA00;
  }
  .memberTotal .miTotalLine li .topTit{
    font-size: 13px;
    height: 17px;
    line-height: 17px;
  }
  .memberTotal .miTotalLine li .botTotal{
    font-size: 20px;
    height: 26px;
    line-height: 26px;
    text-align: end;
  }

  /* 下级代理商区域 */
  .memberTotal .ri-main-box .agentsArea{
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    align-items: flex-start;
  }
  /* 下级代理商区域-单个代理商 */
  .memberTotal .agentsArea .singleAgent{
    width: 108px;
    margin-top: 14px;
    margin-left: 14px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  /* 下级代理商区域-圆圈 */
  .memberTotal .singleAgent .agentCircle{
    width: 108px;
    height: 108px;
    background: linear-gradient(180deg,#FF8000 0%,#FF6600 100%);
    border-radius: 50%;
    color: #ffffff;
  }
  .memberTotal .singleAgent .agentCircle .circleTop{
    width: 100%;
    height: 16px;
    line-height: 16px;
    margin-top: 24px;
    font-size: 12px;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .memberTotal .singleAgent .agentCircle .circleMiddle{
    width: 100%;
    height: 37px;
    line-height: 37px;
    font-size: 28px;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .memberTotal .singleAgent .agentCircle .circleBottom{
    width: 100%;
    height: 16px;
    line-height: 16px;
    margin-top: 4px;
    font-size: 12px;
    text-align: center;
    text-decoration: underline;
  }
  .memberTotal .singleAgent .agentName{
    margin-top: 4px;
    width: 108px;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #333333;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

</style>
